/**
 * 왼쪽 사이드바 — 10개 stage 와 상태 아이콘 + 편집 표시.
 */

import { STAGE_META, STAGE_ORDER, type StageName, type StageStatus } from './stages'

interface Props {
  status: Record<StageName, StageStatus>
  selected: StageName
  onSelect: (stage: StageName) => void
  isEdited: (stage: StageName) => boolean
}

const ICON_FOR: Record<StageStatus, string> = {
  idle: '○',
  running: '⟳',
  done: '✓',
  error: '✕',
  invalidated: '◌',
}

const COLOR_FOR: Record<StageStatus, string> = {
  idle: '#999',
  running: '#1890ff',
  done: '#52c41a',
  error: '#f5222d',
  invalidated: '#faad14',
}

export function StageList({ status, selected, onSelect, isEdited }: Props) {
  return (
    <div
      style={{
        width: 240,
        minWidth: 240,
        borderRight: '1px solid #e5e5e5',
        background: '#fafafa',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}
    >
      <div style={{ padding: '12px 16px', fontSize: 12, color: '#666', textTransform: 'uppercase', letterSpacing: 0.5 }}>
        Pipeline stages
      </div>
      {STAGE_ORDER.map((stage, i) => {
        const st = status[stage]
        const isSelected = selected === stage
        const meta = STAGE_META[stage]
        const edited = isEdited(stage)
        return (
          <button
            key={stage}
            onClick={() => onSelect(stage)}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
              padding: '10px 16px',
              border: 'none',
              borderLeft: isSelected ? '3px solid #1890ff' : '3px solid transparent',
              background: isSelected ? '#e6f4ff' : 'transparent',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: 13,
              color: '#333',
              transition: 'background 0.1s',
            }}
            onMouseEnter={(e) => { if (!isSelected) (e.currentTarget as HTMLButtonElement).style.background = '#f0f0f0' }}
            onMouseLeave={(e) => { if (!isSelected) (e.currentTarget as HTMLButtonElement).style.background = 'transparent' }}
          >
            <div style={{ color: COLOR_FOR[st], fontSize: 14, minWidth: 14, textAlign: 'center', lineHeight: '18px' }}>
              {ICON_FOR[st]}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontSize: 11, color: '#999' }}>{String(i + 1).padStart(2, '0')}</span>
                <span style={{ fontWeight: 500 }}>{meta.label}</span>
                {edited && (
                  <span style={{ fontSize: 10, padding: '1px 6px', background: '#fff7e6', color: '#d48806', border: '1px solid #ffd591', borderRadius: 3 }}>
                    edited
                  </span>
                )}
              </div>
              <div style={{ fontSize: 11, color: '#777', marginTop: 2, lineHeight: 1.3 }}>{meta.description}</div>
            </div>
          </button>
        )
      })}
    </div>
  )
}
